import { render } from "./Team_m.vue?vue&type=template&id=1bb5e045"
import script from "./Team_m.vue?vue&type=script&lang=js"
export * from "./Team_m.vue?vue&type=script&lang=js"
script.render = render

export default script